import { render, staticRenderFns } from "./defaultBackgroundImage.vue?vue&type=template&id=8a5850d2&scoped=true"
import script from "./defaultBackgroundImage.vue?vue&type=script&lang=js"
export * from "./defaultBackgroundImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5850d2",
  null
  
)

export default component.exports